import type { SelectHTMLAttributes } from 'react'
import styles from './Select.module.css'

interface SelectOption {
  value: string
  label: string
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: SelectOption[]
  invalid?: boolean
}

/**
 * Список на родном `<select>`.
 *
 * Самодельный выпадающий список выглядит одинаково везде, но теряет
 * всё, что даёт системный: набор первых букв, поведение на телефоне,
 * работу со скринридером. Здесь список в два десятка часовых поясов —
 * переписывать его ради стрелки нужного оттенка не стоит.
 */
export function Select({ options, invalid, className, ...rest }: SelectProps) {
  const classes = [styles.select, invalid && styles.invalid, className].filter(Boolean).join(' ')

  return (
    <span className={styles.wrapper}>
      <select className={classes} {...rest}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <svg
        className={styles.arrow}
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M1 1.5L6 6.5L11 1.5"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}
